export const initialState = {
    filter: {
      question: null,
      tagName: null,
      answerAlternativeCode: null,
      page: 0,
      size: 10,
    },
    isFilter: false,
    typeAction: null
  };
  
  const questionSearchReducer = (state = initialState, action) => {

    switch (action.type) {
      case "SET_FILTER_QUESTION":
        return {
          ...state,
          filter: action.filter,
          isFilter: action.isFilter,
          typeAction: action.typeAction
        };
      default:
        return state;
    }
  };
  
  export default questionSearchReducer;
  